import { restApiIP } from "@plannel/services/utils/rest-api";

const getAllScenarios = () => {
  return restApiIP.get("/api/ip/scenario-comp");
}

const release = (params) => {
  const releaseParams = {
    ...params,
    nowDate: new ZDate(),
  }

  return restApiIP.post("/api/ip/scenario-comp/release", releaseParams);
}
const ipScenarioCompService = {
  getAllScenarios,
  release
};

export default ipScenarioCompService;